/**
 * @file 横版短视频页
 * @author yanyiting@baidu.com
 */

import app from '@app';
import {Component} from 'san';
import './index.scss';
import ImgText from '@components/img-text';
import AttentionBar from '@components/attention-bar';
import BigTitle from '@components/big-title';
import InvokeAppBar from '@components/invoke-app-bar';
import CommentCard from '@components/comment-card';
import RecommendCard from '@components/recommend-card';
import Video from '@components/video';
import TopBar from '@components/top-bar';
import {sendLog} from '@utils/log';
import InvokeAppBanner from '@components/invoke-app-banner';
import InvokeAppBubble from '@components/invoke-app-bubble';
import {openAppNaPage} from '@utils/open-app';
import getFr from '@utils/get-fr';

const NEW_CHANNEL_NUMBER = '1024447e';
const INVOKE_CHANNEL_NUMBER = '1024447f';

export default class AppComponent extends Component {
    constructor(opts) {
        super(opts);
    }
    static template = `
        <div class="wrap">
            <components-top-bar></components-top-bar>
            <div class="card-container">
                <components-attention-bar
                    class="attention-com common-padding"
                    reflow="{{reflow}}"
                    avatar="{{author.avatar}}"
                    name="{{author.nickname}}"
                    brief="{{author.brief}}"
                    on-confirm-click="followBarClick"/>
                <components-video
                    ratio="{{videoRatio}}"
                    on-play="play"
                    on-playing="playing"
                    playUrl="{{playUrl}}"
                    cover="{{cover}}" />
                <components-big-title
                    class="big-title-com common-padding"
                    data="{{titleData}}" />
                <components-img-text
                    class="img-text-com common-padding"
                    data="{{contentData}}" />
            </div>
            <components-invoke-app-banner
                bannerItem="{{bannerData}}"
                on-banner-click="bannerClick"
                s-if="reflow"/>  
            <components-comment-card
                s-if="reflow"
                class="card-container"
                commentNum="{{commentNum}}"
                commentAvatar="{{commentAvatar}}"
                list="{{commentList}}"
                on-inputclick="invokeClick('comInput')"
                on-likeclick="invokeClick('comLike')"
                on-seereplyclick="invokeClick('comMore')"
                on-seecommentclick="invokeClick('comMore')" />
            <components-recommend-card
                reflow="{{reflow}}"
                list="{{recommendData}}"
                on-moreclick="relateMoreClick"
                on-likeclick="invokeClick('relateLike')"
                on-itemclick="recItemClick" />
            <components-invoke-app-bar
                s-if="reflow"
                barList="{{recBarList}}"
                on-go-click="barClick" />
            <components-invoke-app-bubble
                s-if="reflow"
                on-go-click="bubbleClick"
                bubbleItem="{{bubbleData}}"/>
        </div>
    `;
    static components = {
        'components-attention-bar': AttentionBar,
        'components-big-title': BigTitle,
        'components-video': Video,
        'components-img-text': ImgText,
        'components-comment-card': CommentCard,
        'components-recommend-card': RecommendCard,
        'components-invoke-app-bar': InvokeAppBar,
        'components-top-bar': TopBar,
        'components-invoke-app-banner': InvokeAppBanner,
        'components-invoke-app-bubble': InvokeAppBubble
    };
    initData() {
        const {video, comment, rec, banner, bubble, recBarList, downloadLinks} = window.INITIAL_DATA.data;
        const {
            gemId,
            gemType,
            title,
            desc = '',
            commentNum,
            commentAvatar,
            author,
            cover = {},
            playUrl,
            videoWidth,
            videoHeight
        } = video;

        return {
            videoRatio: videoHeight / videoWidth * 100 + '%',
            gemId,
            gemType,
            author,
            playUrl,
            cover: cover.url,
            titleData: title,
            contentData: [{
                type: 'text',
                data: (desc || '').split('\n')
            }],
            commentList: comment,
            commentNum,
            commentAvatar,
            recommendData: rec,
            reflow: getFr() !== 'top1',
            bannerData: banner,
            bubbleData: bubble,
            recBarList,
            downloadLinks
        };
    }
    attached() {
        sendLog('pv');
    }
    barClick({gemId, gemType}) {
        this.invokeAppByConfig({
            id: gemId,
            type: gemType,
            useCopy: true
        });
        sendLog('clk', {
            value: 'floatBar'
        });
    }
    bannerClick(data) {
        this.bannerOrBarClick(data, 'banner');
    }
    bubbleClick(data) {
        this.bannerOrBarClick(data, 'bubble');
    }
    bannerOrBarClick(data, type) {
        let {jumpType, url, bannerId} = data;
        if (jumpType === 2) {
            window.location.href = url;
        }
        else if (jumpType === 3) {
            let useCopy = type === 'banner';
            this.invokeAppByScheme({
                scheme: url,
                useCopy
            });
        }
        sendLog('clk', {
            value: type,
            ext: {
                'element_id': bannerId
            }
        });
    }
    invokeAppByScheme(opt) {
        let {scheme, useCopy} = opt;
        openAppNaPage(
            scheme,
            {
                invokeCN: INVOKE_CHANNEL_NUMBER,
                newCN: NEW_CHANNEL_NUMBER,
                wait: 1000,
                useCopy
            }
        );
    }
    invokeAppByConfig(data) {
        let {id, type, useCopy} = data;
        openAppNaPage(
            {
                id,
                type
            },
            {
                wait: 1000,
                useCopy,
                invokeCN: INVOKE_CHANNEL_NUMBER,
                newCN: NEW_CHANNEL_NUMBER
            }
        );
    }
    followBarClick() {
        let author = this.data.get('author');
        let {isAppraiser, buid} = author;
        let type = 9;
        if (isAppraiser) {
            type = 10;
        }
        let data = {
            id: buid,
            type,
            useCopyf: true
        };
        this.invokeAppByConfig(data);
        sendLog('clk', {
            value: 'followBar'
        });
    }
    // 回流App
    invokeClick(position) {
        sendLog('clk', {
            value: position
        });
        let data = {
            id: this.data.get('gemId'),
            type: this.data.get('gemType'),
            useCopy: true
        };
        this.invokeAppByConfig(data);
    }
    relateMoreClick() {
        let data = {
            type: 0
        };
        this.invokeAppByConfig(data);
        sendLog('clk', {
            value: 'relateMore'
        });
    }
    // 点击相关推荐卡
    recItemClick(item) {
        let reflow = this.data.get('reflow');
        if (reflow) {
            let data = {
                id: item.gemId,
                type: item.gemType,
                useCopy: true
            };
            this.invokeAppByConfig(data);
        }
        sendLog('clk', {
            value: 'relateCard'
        });
    }
    // 点击播放视频
    play() {
        sendLog('play', {
            value: 'video'
        });
    }
}
app(AppComponent, '#app');
